// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_DeletaOrcamentoServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Agenda_DeletaOrcamentoServicoResponseDados = boolean;

export type Agenda_DeletaOrcamentoServicoResponse = ApiResponse<Agenda_DeletaOrcamentoServicoResponseDados>;

registerResponseContract('Agenda_DeletaOrcamentoServicoResponse', {})
